import ApiClient from './ApiClient';

class QuotesAPI extends ApiClient {
  constructor() {
    super('quotes', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  show(quoteId) {
    return axios.get(`${this.url}/${quoteId}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(quoteId, data) {
    return axios.patch(`${this.url}/${quoteId}`, data);
  }

  delete(quoteId) {
    return axios.delete(`${this.url}/${quoteId}`);
  }

  markAsSold(quoteId, payments = []) {
    return axios.post(`${this.url}/${quoteId}/mark_as_sold`, { payments });
  }

  updatePayments(quoteId, payments = []) {
    return axios.put(`${this.url}/${quoteId}/update_payments`, { payments });
  }

  getPayments(quoteId) {
    return axios.get(`${this.url}/${quoteId}/payments`);
  }

  getSalesReport(params = {}) {
    return axios.get(`${this.url}/sales_report`, { params });
  }

  getDeliveryReport(params = {}) {
    return axios.get(`${this.url}/delivery_report`, { params });
  }

  markAsSeparated(
    quoteId,
    { deliveryType, deliveryPersonId, deliveryPersonName, deliveryPersonPhone }
  ) {
    return axios.post(`${this.url}/${quoteId}/mark_as_separated`, {
      delivery_type: deliveryType,
      delivery_person_id: deliveryPersonId,
      delivery_person_name: deliveryPersonName,
      delivery_person_phone: deliveryPersonPhone,
    });
  }

  markAsOutForDelivery(quoteId) {
    return axios.post(`${this.url}/${quoteId}/mark_as_out_for_delivery`);
  }

  markAsDelivered(quoteId) {
    return axios.post(`${this.url}/${quoteId}/mark_as_delivered`);
  }

  markAsCancelled(quoteId) {
    return axios.post(`${this.url}/${quoteId}/mark_as_cancelled`);
  }

  resendDriverNotification(quoteId) {
    return axios.post(`${this.url}/${quoteId}/resend_driver_notification`);
  }

  markDeliveryAsPaid(quoteId) {
    return axios.post(`${this.url}/${quoteId}/mark_delivery_as_paid`);
  }

  markDeliveryAsUnpaid(quoteId) {
    return axios.post(`${this.url}/${quoteId}/mark_delivery_as_unpaid`);
  }

  // Items
  getItems(quoteId) {
    return axios.get(`${this.url}/${quoteId}/items`);
  }

  createItem(quoteId, data) {
    return axios.post(`${this.url}/${quoteId}/items`, data);
  }

  updateItem(quoteId, itemId, data) {
    return axios.patch(`${this.url}/${quoteId}/items/${itemId}`, data);
  }

  deleteItem(quoteId, itemId) {
    return axios.delete(`${this.url}/${quoteId}/items/${itemId}`);
  }

  reorderItems(quoteId, positions) {
    return axios.post(`${this.url}/${quoteId}/items/reorder`, { positions });
  }
}

export default new QuotesAPI();
